import { state, materialState, turkish } from "./../controls/state.js"
import { useSnapshot } from "valtio"
import React, { useRef, useState, useEffect, useLayoutEffect } from "react"
import { useGLTF } from "@react-three/drei"
import * as mats from "./mats.js"

function Volvo(props) {
    const group = useRef()
    
    const { scene, nodes, materials} = useGLTF("models/volvo.glb")
    const custom = mats.getMaterial()
    
    const snap = useSnapshot(state)
    const materialSnap = useSnapshot(materialState)
    
    const [hovered, set] = useState(null)
    useEffect(() => {
      const cursor = `<svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path fill="rgba(255, 255, 255, 0.5)" d="M29.5 54C43.031 54 54 43.031 54 29.5S43.031 5 29.5 5 5 15.969 5 29.5 15.969 54 29.5 54z" stroke="#000"/><g filter="url(#filter0_d)"><path d="M29.5 47C39.165 47 47 39.165 47 29.5S39.165 12 29.5 12 12 19.835 12 29.5 19.835 47 29.5 47z" fill="${snap.items[hovered]}"/></g><path d="M2 2l11 2.947L4.947 13 2 2z" fill="#000"/><text fill="#000" style="white-space:pre" font-family="Inter var, sans-serif" font-size="10" letter-spacing="-.01em"><tspan x="35" y="63">${turkish[hovered]}</tspan></text></g><defs><clipPath id="clip0"><path fill="#fff" d="M0 0h64v64H0z"/></clipPath><filter id="filter0_d" x="6" y="8" width="47" height="47" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="2"/><feGaussianBlur stdDeviation="3"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>`
      const auto = `<svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="rgba(255, 255, 255, 0.5)" d="M29.5 54C43.031 54 54 43.031 54 29.5S43.031 5 29.5 5 5 15.969 5 29.5 15.969 54 29.5 54z" stroke="#000"/><path d="M2 2l11 2.947L4.947 13 2 2z" fill="#000"/></svg>`
      document.body.style.cursor = `url('data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(hovered ? cursor : auto)))}'), auto`
    }, [hovered])  
   
 
    return (
      <group
        ref={group}
        {...props}
        dispose={null}
        onPointerOver={(e) => (e.stopPropagation(), set(e.object.material.name))}
        onPointerOut={(e) => e.intersections.length === 0 && set(null)}
        onPointerMissed={() => (state.current = null)}
        onPointerDown={(e) => (e.stopPropagation(), (state.current = e.object.material.name))}>
      <group position={[-0.01, -0.07, 0]} rotation={[Math.PI / 2, 0, -2.67]}>
        <group rotation={[-Math.PI, 0, 0]}>
          <group position={[0, 0, 691.92]}>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.black_body_black_0.geometry} material={nodes.black_body_black_0.material} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <group position={[0.1, 20.29, -321.54]}>
                <mesh
                  geometry={nodes.black_dashboard_black_0.geometry}
                  material={nodes.black_dashboard_black_0.material}
                />
              </group>
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.black_roof_black_0.geometry} material={nodes.black_roof_black_0.material} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.black_window_f_black_0.geometry} material={nodes.black_window_f_black_0.material} />
            </group>
            <group position={[0, -20.18, -1360.69]}>
              <mesh geometry={nodes.black_window_r_black_0.geometry} material={nodes.black_window_r_black_0.material} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.black_windows_rs_black_0.geometry}
                material={nodes.black_windows_rs_black_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_body_l_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_body_r_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_bumper_f_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_bumper_r_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_bumper_r_sensor_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_door_handles_f_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_door_handles_r_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_doors_f_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_doors_r_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_fenders_f_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_hood_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_mirrors_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_roof_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_sensors_f_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_sideSkirts_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_spoiler_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.carpaint_tailgate_carpaint_0.geometry}
                material={custom["c" + materialSnap.items["car_paint"]]}
                material-color={snap.items.car_paint}
              />
            </group>
            <group position={[548.51, -2276.22, -612.02]} rotation={[Math.PI / 2, 0, 0]}>
              <mesh geometry={nodes.chrome_awd_chrome_0.geometry} material={nodes.chrome_awd_chrome_0.material} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.chrome_bumper_f_chrome_0.geometry}
                material={nodes.chrome_bumper_f_chrome_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.chrome_bumper_r_chrome_0.geometry}
                material={nodes.chrome_bumper_r_chrome_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.chrome_grill_chrome_0.geometry} material={nodes.chrome_grill_chrome_0.material} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.chrome_grill_bars_chrome_0.geometry}
                material={nodes.chrome_grill_bars_chrome_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.chrome_headlights_side_chrome_0.geometry}
                material={nodes.chrome_headlights_side_chrome_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.chrome_logo_f_chrome_0.geometry} material={nodes.chrome_logo_f_chrome_0.material} />
            </group>
            <group position={[499.96, -2283.36, -601.35]}>
              <group position={[-499.96, 2263.52, -759.34]}>
                <mesh geometry={nodes.chrome_t6_chrome_0.geometry} material={nodes.chrome_t6_chrome_0.material} />
              </group>
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.chrome_taillight_chrome_0.geometry}
                material={nodes.chrome_taillight_chrome_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.chrome_taillight001_chrome_0.geometry}
                material={nodes.chrome_taillight001_chrome_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.chrome_v60_chrome_0.geometry} material={nodes.chrome_v60_chrome_0.material} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.chrome_volvo_chrome_0.geometry} material={nodes.chrome_volvo_chrome_0.material} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.chrome_windows_trim_chrome_0.geometry}
                material={nodes.chrome_windows_trim_chrome_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.glassBumpA_taillight_small_glass_bumpA_0.geometry}
                material={materials.glass_bumpA}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.glassClear_foglight_glass_clear_0.geometry}
                material={nodes.glassClear_foglight_glass_clear_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.glassClear_headlight_glass_clear_0.geometry}
                material={nodes.glassClear_headlight_glass_clear_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.glassClear_mirrors_glass_clear_0.geometry}
                material={nodes.glassClear_mirrors_glass_clear_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.glassClear_taillight_glass_clear_0.geometry}
                material={nodes.glassClear_taillight_glass_clear_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.glassDark_window_f_glass_dark_0.geometry} material={custom["fg" + materialSnap.items["front_glass"]]} material-color={snap.items.front_glass} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.glassDark_window_fs_glass_dark_0.geometry} material={custom["fsg" + materialSnap.items["front_side_glass"]]} material-color={snap.items.front_side_glass} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.glassDark_window_r_glass_dark_0.geometry} material={custom["bg" + materialSnap.items["back_glass"]]} material-color={snap.items.back_glass}/>
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.glassDark_windows_rs_glass_dark_0.geometry} material={custom["bsg" + materialSnap.items["back_side_glass"]]} material-color={snap.items.back_side_glass} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.glassDarkB_roof_glass_darkB_0.geometry} material={materials.glass_darkB} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.glassLed_headlight_glass_led_0.geometry} material={materials.glass_led} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <group position={[0.1, 0, -321.6]}>
                <mesh
                  geometry={nodes.glassLens_dashboard_glass_lens_0.geometry}
                  material={nodes.glassLens_dashboard_glass_lens_0.material}
                />
              </group>
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.glassLens_headlight_glass_lens_0.geometry}
                material={nodes.glassLens_headlight_glass_lens_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.glassLens_mirror_glass_lens_0.geometry}
                material={nodes.glassLens_mirror_glass_lens_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.glassRed_taillight_glass_red_0.geometry}
                material={nodes.glassRed_taillight_glass_red_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.glassRed_taillight001_glass_red_0.geometry}
                material={nodes.glassRed_taillight001_glass_red_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.glassRed_taillight_small_glass_red_0.geometry}
                material={nodes.glassRed_taillight_small_glass_red_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.glassRedB_taillight_glass_redB_0.geometry} material={materials.glass_redB} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.glassRedf_stop_light_glass_red_0.geometry}
                material={nodes.glassRedf_stop_light_glass_red_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <group position={[0.1, 0, -323.37]}>
                <mesh
                  geometry={nodes.interiorA_dashboard_interiorA_0.geometry}
                  material={nodes.interiorA_dashboard_interiorA_0.material}
                />
              </group>
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.interiorA_doorPanels_interiorA_0.geometry}
                material={nodes.interiorA_doorPanels_interiorA_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.interiorA_steering_col_interiorA_0.geometry}
                material={nodes.interiorA_steering_col_interiorA_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.interiorA_top_interiorA_0.geometry}
                material={nodes.interiorA_top_interiorA_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.interiorB_floor_interiorB_0.geometry} material={materials.interiorB} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.leatherA_armrest_leatherA_0.geometry}
                material={nodes.leatherA_armrest_leatherA_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.leatherA_seats_f_leatherA_0.geometry}
                material={nodes.leatherA_seats_f_leatherA_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.leatherA_seats_r_leatherA_0.geometry}
                material={nodes.leatherA_seats_r_leatherA_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.leatherA_steering_wheel_leatherA_0.geometry}
                material={nodes.leatherA_steering_wheel_leatherA_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.leatherB_dashboard_leatherB_0.geometry}
                material={nodes.leatherB_dashboard_leatherB_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.leatherB_doors_leatherB_0.geometry}
                material={nodes.leatherB_doors_leatherB_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.leatherB_steering_wheel_leatherB_0.geometry}
                material={nodes.leatherB_steering_wheel_leatherB_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.metalDark_radiator_metal_dark_0.geometry}
                material={nodes.metalDark_radiator_metal_dark_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_bumper_f_plasticblack_0.geometry}
                material={nodes.plastic_bumper_f_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_bumper_f_details_plasticblack_0.geometry}
                material={nodes.plastic_bumper_f_details_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_bumper_f_sides_plasticblack_0.geometry}
                material={nodes.plastic_bumper_f_sides_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_bumper_r_plasticblack_0.geometry}
                material={nodes.plastic_bumper_r_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_bumper_r_details_plasticblack_0.geometry}
                material={nodes.plastic_bumper_r_details_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_grill_plasticblack_0.geometry}
                material={nodes.plastic_grill_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_headlights_plasticblack_0.geometry}
                material={nodes.plastic_headlights_plasticblack_0.material}
              />
            </group>
            <group position={[0, 2354.73, -941.75]}>
              <mesh
                geometry={nodes.plastic_licencePlate_f_plasticblack_0.geometry}
                material={nodes.plastic_licencePlate_f_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_licencePlate_r_plasticblack_0.geometry}
                material={nodes.plastic_licencePlate_r_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_logo_f_plasticblack_0.geometry}
                material={nodes.plastic_logo_f_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_roof_plasticblack_0.geometry}
                material={nodes.plastic_roof_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_roof_int_plasticblack_0.geometry}
                material={nodes.plastic_roof_int_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_spoiler_plasticblack_0.geometry}
                material={nodes.plastic_spoiler_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_steering_wheel_plasticblack_0.geometry}
                material={nodes.plastic_steering_wheel_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_taillight_small_plasticblack_0.geometry}
                material={nodes.plastic_taillight_small_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_windows_side_plasticblack_0.geometry}
                material={nodes.plastic_windows_side_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_windshield_plasticblack_0.geometry}
                material={nodes.plastic_windshield_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_wiper_r_plasticblack_0.geometry}
                material={nodes.plastic_wiper_r_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plastic_wipers_f_plasticblack_0.geometry}
                material={nodes.plastic_wipers_f_plasticblack_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <group position={[0.1, 20.29, -321.54]}>
                <mesh
                  geometry={nodes.plasticGlossy_dashboard_plasticGlossy_0.geometry}
                  material={nodes.plasticGlossy_dashboard_plasticGlossy_0.material}
                />
              </group>
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plasticGlossy_headlights_plasticGlossy_0.geometry}
                material={nodes.plasticGlossy_headlights_plasticGlossy_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plasticGlossy_in_plasticGlossy_0.geometry}
                material={nodes.plasticGlossy_in_plasticGlossy_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plasticGlossy_logo_f_plasticGlossy_0.geometry}
                material={nodes.plasticGlossy_logo_f_plasticGlossy_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plasticGlossy_mirrors_plasticGlossy_0.geometry}
                material={nodes.plasticGlossy_mirrors_plasticGlossy_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plasticGlossy_pillars_plasticGlossy_0.geometry}
                material={nodes.plasticGlossy_pillars_plasticGlossy_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plasticGlossy_stop_light_plasticGlossy_0.geometry}
                material={nodes.plasticGlossy_stop_light_plasticGlossy_0.material}
              />
            </group>
            <group position={[0, -20.09, -1360.69]}>
              <mesh
                geometry={nodes.plasticGlossy_T6_plasticGlossy_0.geometry}
                material={nodes.plasticGlossy_T6_plasticGlossy_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plasticGlossy_taillight_small_plasticGlossy_0.geometry}
                material={nodes.plasticGlossy_taillight_small_plasticGlossy_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <group position={[0, 0, -321.54]}>
                <mesh
                  geometry={nodes.plasticInt_dashboard_plastic_int_0.geometry}
                  material={nodes.plasticInt_dashboard_plastic_int_0.material}
                />
              </group>
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plasticInt_doors_plastic_int_0.geometry}
                material={nodes.plasticInt_doors_plastic_int_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plasticInt_mirror__plastic_int_0.geometry}
                material={nodes.plasticInt_mirror__plastic_int_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.plasticInt_taillight_plastic_int_0.geometry}
                material={nodes.plasticInt_taillight_plastic_int_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.redIllum_taillight_glass_red_illum_0.geometry}
                material={materials.glass_red_illum}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.reflect_foglights_reflect_0.geometry}
                material={nodes.reflect_foglights_reflect_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.reflect_headlight_in_reflect_0.geometry}
                material={nodes.reflect_headlight_in_reflect_0.material}
              />
              <mesh
                geometry={nodes.reflect_headlight_in_reflect_0001.geometry}
                material={nodes.reflect_headlight_in_reflect_0001.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.reflect_headlights_reflect_0.geometry}
                material={nodes.reflect_headlights_reflect_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.reflect_mirror_interior_reflect_0.geometry}
                material={nodes.reflect_mirror_interior_reflect_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.reflect_mirrors_reflect_0.geometry}
                material={nodes.reflect_mirrors_reflect_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.reflect_stop_light_reflect_0.geometry}
                material={nodes.reflect_stop_light_reflect_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.reflect_taillight_small_reflect_0.geometry}
                material={nodes.reflect_taillight_small_reflect_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.reflectDark_mirror_reflectDark_0.geometry}
                material={nodes.reflectDark_mirror_reflectDark_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.reflectDark_taillight_reflectDark_0.geometry}
                material={nodes.reflectDark_taillight_reflectDark_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.reflectDark_taillight_reflectDark_0001.geometry}
                material={nodes.reflectDark_taillight_reflectDark_0001.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.reflectDark_taillight_reflectDark_0002.geometry}
                material={nodes.reflectDark_taillight_reflectDark_0002.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.reflectDarkBumpA_taillight_reflectDarkBumpA_0.geometry}
                material={materials.reflectDarkBumpA}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <group position={[0.1, 0, -321.54]}>
                <mesh
                  geometry={nodes.silver_dashboard_silver_0.geometry}
                  material={nodes.silver_dashboard_silver_0.material}
                />
              </group>
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <group position={[0.1, 0, -321.54]}>
                <mesh
                  geometry={nodes.silver_dashboard_bar_silver_0.geometry}
                  material={nodes.silver_dashboard_bar_silver_0.material}
                />
              </group>
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.silver_headlights_silver_0.geometry}
                material={nodes.silver_headlights_silver_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.silver_roof_silver_0.geometry} material={nodes.silver_roof_silver_0.material} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.silver_steering_wheel_silver_0.geometry}
                material={nodes.silver_steering_wheel_silver_0.material}
              />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <group position={[0, 0, 33.02]}>
                <mesh
                  geometry={nodes.texInt_dashboard_int_0.geometry}
                  material={nodes.texInt_dashboard_int_0.material}
                />
              </group>
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh geometry={nodes.texInt_doors_int_0.geometry} material={nodes.texInt_doors_int_0.material} />
            </group>
            <group position={[0, -18.33, -1360.69]}>
              <mesh
                geometry={nodes.texInt_steering_wheel_int_0.geometry}
                material={nodes.texInt_steering_wheel_int_0.material}
              />
            </group>
            <group position={[-779.81, 1509.67, -1038.79]}>
              <group position={[-21.25, 0.3, -0.1]} scale={1.05}>
                <mesh
                  geometry={nodes.brakedisc_000_chrome_brushed_brakedisc_0.geometry}
                  material={nodes.brakedisc_000_chrome_brushed_brakedisc_0.material}
                />
              </group>
              <group position={[851.45, -1596.47, -351.32]} scale={1.05}>
                <mesh
                  geometry={nodes.chrome_wheel_logo_000_chrome_0.geometry}
                  material={nodes.chrome_wheel_logo_000_chrome_0.material}
                />
              </group>
              <group position={[-22.62, 133.5, 49.25]} scale={1.05}>
                <mesh
                  geometry={nodes.metalDark_brakeCaliper000_metal_dark_0.geometry}
                  material={nodes.metalDark_brakeCaliper000_metal_dark_0.material}
                />
              </group>
              <group position={[851.45, -1596.47, -351.32]} scale={1.05}>
                <mesh
                  geometry={nodes.metalDark_rimIn_000_metal_dark_0.geometry}
                  material={nodes.metalDark_rimIn_000_metal_dark_0.material}
                />
              </group>
              <group position={[-28.27, 0.34, -0.06]} scale={1.05}>
                <mesh
                  geometry={nodes.metalDark_wheel_000_metal_dark_0.geometry}
                  material={nodes.metalDark_wheel_000_metal_dark_0.material}
                />
              </group>
              <group position={[851.45, -1596.47, -351.32]} scale={1.05}>
                <mesh
                  geometry={nodes.plastic_wheel_bolts000_plasticblack_0.geometry}
                  material={nodes.plastic_wheel_bolts000_plasticblack_0.material}
                />
              </group>
              <group position={[851.45, -1596.47, -351.32]} scale={1.05}>
                <mesh
                  geometry={nodes.plastic_wheel_logo000_plasticblack_0.geometry}
                  material={nodes.plastic_wheel_logo000_plasticblack_0.material}
                />
              </group>
              <group position={[851.45, -1596.47, -351.32]} scale={1.05}>
                <mesh
                  geometry={nodes.rimBright_000_rimBright_0.geometry}
                  material={nodes.rimBright_000_rimBright_0.material}
                />
              </group>
              <group position={[851.45, -1596.47, -351.32]} scale={1.05}>
                <mesh geometry={nodes.rimDark_000_rimDark_0.geometry} material={nodes.rimDark_000_rimDark_0.material} />
              </group>
              <group position={[-4.33, 0, 0]} scale={0.95}>
                <group position={[-667.25, 37.87, 60.56]}>
                  <mesh geometry={nodes.tire_000_tire_0.geometry} material={nodes.tire_000_tire_0.material} />
                  <mesh geometry={nodes.tire_000_tire_0001.geometry} material={nodes.tire_000_tire_0001.material} />
                </group>
              </group>
            </group>
            <group position={[-779.81, -1370.21, -1038.79]}>
              <group position={[-21.25, 0.3, -0.1]} scale={[1.05, 1, 1]}>
                <mesh
                  geometry={nodes.brakedisc_001_chrome_brushed_brakedisc_0.geometry}
                  material={nodes.brakedisc_001_chrome_brushed_brakedisc_0.material}
                />
              </group>
              <group position={[851.45, -1596.47, -351.32]} scale={1.05}>
                <mesh
                  geometry={nodes.chrome_wheel_logo_001_chrome_0.geometry}
                  material={nodes.chrome_wheel_logo_001_chrome_0.material}
                />
              </group>
              <group position={[-4.59, 92.71, 110.58]} rotation={[0.87, 0, 0]}>
                <mesh
                  geometry={nodes.metalDark_Caliper_001_metal_dark_0.geometry}
                  material={nodes.metalDark_Caliper_001_metal_dark_0.material}
                />
              </group>
              <group position={[851.45, -1596.47, -351.32]} scale={1.05}>
                <mesh
                  geometry={nodes.metalDark_rimIn_001_metal_dark_0.geometry}
                  material={nodes.metalDark_rimIn_001_metal_dark_0.material}
                />
              </group>
              <group position={[-28.27, 0.34, -0.06]} scale={1.05}>
                <mesh
                  geometry={nodes.metalDark_wheel_001_metal_dark_0.geometry}
                  material={nodes.metalDark_wheel_001_metal_dark_0.material}
                />
              </group>
              <group position={[851.45, -1596.47, -351.32]} scale={1.05}>
                <mesh
                  geometry={nodes.plastic_wheel_bolts001_plasticblack_0.geometry}
                  material={nodes.plastic_wheel_bolts001_plasticblack_0.material}
                />
              </group>
              <group position={[851.45, -1596.47, -351.32]} scale={1.05}>
                <mesh
                  geometry={nodes.plastic_wheel_logo001_plasticblack_0.geometry}
                  material={nodes.plastic_wheel_logo001_plasticblack_0.material}
                />
              </group>
              <group position={[851.45, -1596.47, -351.32]} scale={1.05}>
                <mesh
                  geometry={nodes.rimBright_001_rimBright_0.geometry}
                  material={nodes.rimBright_001_rimBright_0.material}
                />
              </group>
              <group position={[851.45, -1596.47, -351.32]} scale={1.05}>
                <mesh geometry={nodes.rimDark_001_rimDark_0.geometry} material={nodes.rimDark_001_rimDark_0.material} />
              </group>
              <group position={[-4.33, 0, 0]} scale={0.95}>
                <group position={[-667.25, 37.87, 60.56]}>
                  <mesh geometry={nodes.tire_001_tire_0.geometry} material={nodes.tire_001_tire_0.material} />
                  <mesh geometry={nodes.tire_001_tire_0001.geometry} material={nodes.tire_001_tire_0001.material} />
                </group>
              </group>
            </group>
            <group position={[779.81, -1370.21, -1038.79]}>
              <group position={[21.25, 0.3, -0.1]}>
                <mesh
                  geometry={nodes.brakedisc_002_chrome_brushed_brakedisc_0.geometry}
                  material={nodes.brakedisc_002_chrome_brushed_brakedisc_0.material}
                />
              </group>
              <group position={[113.69, 0.05, -0.19]}>
                <mesh
                  geometry={nodes.chrome_wheel_logo_002_chrome_0.geometry}
                  material={nodes.chrome_wheel_logo_002_chrome_0.material}
                />
              </group>
              <group position={[4.59, 92.71, 110.58]}>
                <mesh
                  geometry={nodes.metalDark_Caliper_002_metal_dark_0.geometry}
                  material={nodes.metalDark_Caliper_002_metal_dark_0.material}
                />
              </group>
              <group position={[-851.45, -1596.47, -351.32]}>
                <mesh
                  geometry={nodes.metalDark_rimIn_002_metal_dark_0.geometry}
                  material={nodes.metalDark_rimIn_002_metal_dark_0.material}
                />
              </group>
              <group position={[28.27, 0.34, -0.06]}>
                <mesh
                  geometry={nodes.metalDark_wheel_002_metal_dark_0.geometry}
                  material={nodes.metalDark_wheel_002_metal_dark_0.material}
                />
              </group>
              <group position={[-851.45, -1596.47, -351.32]}>
                <mesh
                  geometry={nodes.plastic_wheel_bolts002_plasticblack_0.geometry}
                  material={nodes.plastic_wheel_bolts002_plasticblack_0.material}
                />
              </group>
              <group position={[-851.45, -1596.47, -351.32]}>
                <mesh
                  geometry={nodes.plastic_wheel_logo002_plasticblack_0.geometry}
                  material={nodes.plastic_wheel_logo002_plasticblack_0.material}
                />
              </group>
              <group position={[-851.45, -1596.47, -351.32]}>
                <mesh
                  geometry={nodes.rimBright_002_rimBright_0.geometry}
                  material={nodes.rimBright_002_rimBright_0.material}
                />
              </group>
              <group position={[-851.45, -1596.47, -351.32]}>
                <mesh geometry={nodes.rimDark_002_rimDark_0.geometry} material={nodes.rimDark_002_rimDark_0.material} />
              </group>
              <group position={[4.33, 0, 0]}>
                <mesh geometry={nodes.tire_002_tire_0.geometry} material={nodes.tire_002_tire_0.material} />
                <mesh geometry={nodes.tire_002_tire_0001.geometry} material={nodes.tire_002_tire_0001.material} />
                <mesh geometry={nodes.tire_002_tire_0002.geometry} material={nodes.tire_002_tire_0002.material} />
              </group>
            </group>
            <group position={[779.81, 1509.67, -1038.79]}>
              <group position={[21.25, 0.3, -0.1]}>
                <mesh
                  geometry={nodes.brakedisc_003_chrome_brushed_brakedisc_0.geometry}
                  material={nodes.brakedisc_003_chrome_brushed_brakedisc_0.material}
                />
              </group>
              <group position={[113.69, 0.05, -0.19]}>
                <mesh
                  geometry={nodes.chrome_wheel_logo_003_chrome_0.geometry}
                  material={nodes.chrome_wheel_logo_003_chrome_0.material}
                />
              </group>
              <group position={[22.62, 133.5, 49.25]}>
                <mesh
                  geometry={nodes.metalDark_brakeCaliper001_metal_dark_0.geometry}
                  material={nodes.metalDark_brakeCaliper001_metal_dark_0.material}
                />
              </group>
              <group position={[-851.45, -1596.47, -351.32]}>
                <mesh
                  geometry={nodes.metalDark_rimIn_003_metal_dark_0.geometry}
                  material={nodes.metalDark_rimIn_003_metal_dark_0.material}
                />
              </group>
              <group position={[28.27, 0.34, -0.06]}>
                <mesh
                  geometry={nodes.metalDark_wheel_003_metal_dark_0.geometry}
                  material={nodes.metalDark_wheel_003_metal_dark_0.material}
                />
              </group>
              <group position={[-851.45, -1596.47, -351.32]}>
                <mesh
                  geometry={nodes.plastic_wheel_bolts003_plasticblack_0.geometry}
                  material={nodes.plastic_wheel_bolts003_plasticblack_0.material}
                />
              </group>
              <group position={[-851.45, -1596.47, -351.32]}>
                <mesh
                  geometry={nodes.plastic_wheel_logo003_plasticblack_0.geometry}
                  material={nodes.plastic_wheel_logo003_plasticblack_0.material}
                />
              </group>
              <group position={[-851.45, -1596.47, -351.32]}>
                <mesh
                  geometry={nodes.rimBright_003_rimBright_0.geometry}
                  material={nodes.rimBright_003_rimBright_0.material}
                />
              </group>
              <group position={[-851.45, -1596.47, -351.32]}>
                <mesh geometry={nodes.rimDark_003_rimDark_0.geometry} material={nodes.rimDark_003_rimDark_0.material} />
              </group>
              <group position={[4.33, 0, 0]}>
                <mesh geometry={nodes.tire_003_tire_0.geometry} material={nodes.tire_003_tire_0.material} />
                <mesh geometry={nodes.tire_003_tire_0001.geometry} material={nodes.tire_003_tire_0001.material} />
                <mesh geometry={nodes.tire_003_tire_0002.geometry} material={nodes.tire_003_tire_0002.material} />
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

export { Volvo }